import { render, staticRenderFns } from "./PromocionBtn.vue?vue&type=template&id=39b8cf2b&"
import script from "./PromocionBtn.vue?vue&type=script&lang=js&"
export * from "./PromocionBtn.vue?vue&type=script&lang=js&"
import style0 from "./PromocionBtn.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports